import React from "react";

import { ReactComponent as AttentionIcon } from "../../../../../assets/icons/attention.svg";
import { useNavigateCustom } from "../../../../../hooks";
import { FeedbackOnlyText } from "../../../../../components/FeedbackOnlyText";

const feedbackText = {
	title: "Você possui contas em aberto",
	description:
          "Efetue o pagamento para continuar usando seus serviços Vivo",
	button: {
		primaryButtonText: "Pagar agora",
		secondaryButtonText: "Ir pro início",
	},
};
const vivoLink = "https://vivoemdia.vivo.com.br/";

export const OpenAccountsFeedback = () => {
	const navigate = useNavigateCustom();
	const handleOnClickPrimaryButton = () => {
		window.open(vivoLink, "_blank");
	};

	const handleOnClickSecondaryButton = () => {
		navigate("/", { replace: true });
	};

	return (
		<FeedbackOnlyText
			data={feedbackText}
			primaryButton={{
				title: feedbackText.button.primaryButtonText,
				onClick: handleOnClickPrimaryButton,
			}}
			secondaryButton={{
				title: feedbackText.button.secondaryButtonText,
				onClick: handleOnClickSecondaryButton,
				variant: "ghost",
			}}
			icon={{
				icon: AttentionIcon,
				w: 58,
				color: "error",
			}}
		/>
	);
};

export default OpenAccountsFeedback;
